import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProjectsComponent } from './projects/projects.component';
import { ProjectCreateComponent } from './project-create/project-create.component';
import { ProjectEditComponent } from './project-edit/project-edit.component';
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { ApiSpecificationsComponent } from './project-details/api-specifications/api-specifications.component';
import { ProjectServicesComponent } from './project-details/project-services/project-services.component';
import { ProjectTeamComponent } from './project-details/project-team/project-team.component';
import { CreateSpecificationComponent } from './project-details/create-specification/create-specification.component';
import { UpdateSpecificationComponent } from './project-details/update-specification/update-specification.component';
import { CreateServiceComponent } from './project-details/create-service/create-service.component';
import { EditServiceComponent } from './project-details/edit-service/edit-service.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'project-create',
    component: ProjectCreateComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'project-edit/:id',
    component: ProjectEditComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'project-details/:id',
    component: ProjectDetailsComponent,
    canActivate: [MsalGuard],
    children: [
      { path: '', redirectTo: 'api-specifications', pathMatch: 'full' },
      { path: 'api-specifications', component: ApiSpecificationsComponent },
      { path: 'create-specification', component: CreateSpecificationComponent },
      { path: 'update-specification/:specId', component: UpdateSpecificationComponent },
      { path: 'services', component: ProjectServicesComponent },
      { path: 'create-service', component: CreateServiceComponent },
      { path: 'edit-service/:serviceId', component: EditServiceComponent },
      { path: 'team', component: ProjectTeamComponent },
    ],
  },
];
